<template>
<div>

    <div class="row">
        <sp-card :valor="bercario_i" sufix="dias" :descricao="'TMA do último mês fechado da fila para crianças ' + $t('graficosEducacao.turmasCreche.bercario_i_eta')" :lgGrid="3" :footerText="dataDiario"/>
        <sp-card :valor="bercario_ii" sufix="dias" :descricao="'TMA do último mês fechado da fila para crianças ' + $t('graficosEducacao.turmasCreche.bercario_ii_eta')" :lgGrid="3" :footerText="dataDiario"/>
        <sp-card :valor="mini_grupo_i" sufix="dias" :descricao="'TMA do último mês fechado da fila para crianças ' + $t('graficosEducacao.turmasCreche.mini_grupo_i_eta')" :lgGrid="3" :footerText="dataDiario"/>
        <sp-card :valor="mini_grupo_ii" sufix="dias" :descricao="'TMA do último mês fechado da fila para crianças ' + $t('graficosEducacao.turmasCreche.mini_grupo_ii_eta')" :lgGrid="3" :footerText="dataDiario"/>
    </div>

    <sp-360-panel class="flex xs12" :title="header" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
        <div id="multiselects" class="flex-box" >
          <multiselect
            id="selectSubprefeituras"
            name="Subprefeituras"
            placeholder="Selecione uma Subprefeitura"
            track-by="nome"
            label="nome"
            :value="subSel"
            :options="subs"
            :close-on-select="true"
            :show-labels="false"
            @input="updateMultiSelect"
          />

          <multiselect
            id="selectSegmentoTemporal"
            name="selectTemporal"
            :placeholder="$t('mainDashboard.filterTablePlaceholder')"
            :value="corteTemporalEscolhido"
            :options="corteTemporal"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            :allowEmpty="false"
            @input="updatesub"
          />
        </div>

        <div class="flex-box"  >
            <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="mapaSP" :habilitarAnimacaoClique="true" :habilitarLegenda='true'/>
            <sp360-chart ref="chart" id="chartTma" :data="chart.data" type="vertical-bar" :options="chart.options"/>
        </div>
    </sp-360-panel>
</div>

</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import * as d3 from 'd3'
import Linha from '@/components/statistics/charts/GraficoLinha.vue'
import MethGlob from '@/utils/MetodosGlobais'
import Multiselect from 'vue-multiselect'
import SpCard from '@/components/dashboard/SP360Card'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import SpMap from '@/components/maps/360-maps/SPMap'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'

export default {
  name: 'tmaCreche',
  components: {
    SpCard, Sp360Panel, Sp360DataTable, SpMap, Multiselect, Linha, Sp360Chart,
  },

  computed: {
    header: function () {
      return 'Tempo Médio de Atendimento da Fila da Creche : ' + (this.subSelecionada || 'São Paulo')
    },
    dataDiario: function () {
      let data = new Date()
      return 'Dados de ' + (MethGlob.mapeiaMesAbreviacao(data.getMonth() + 1).abrev + '/' + data.getFullYear()) // mes atual
    },
    rodape: function () {
      let periodo = this.chart.data.labels ? this.chart.data.labels[this.chart.data.labels.length - 1] : ''
      return 'Mapa pintado baseado nos dados de ' + periodo
    },
    bercario_i: function () {
      return (this.diario.bercario_i || 0)
    },
    bercario_ii: function () {
      return this.diario.bercario_ii || 0
    },
    mini_grupo_i: function () {
      return this.diario.mini_grupo_i || 0
    },
    mini_grupo_ii: function () {
      return this.diario.mini_grupo_ii || 0
    },

  },

  data () {
    return {
      chart: {
        data: {},
      },
      cores: [CorUtils.getVetorCoresPorTom('escuro'), CorUtils.getVetorCoresPorTom('claro')],
      mapaCores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      },
      anual: {},
      mensal: {},
      diario: {
        bercario_i: { hoje: {} },
        bercario_ii: { hoje: {} },
        mini_grupo_i: { hoje: {} },
        mini_grupo_ii: { hoje: {} },
      },
      dadosDiarios: null,
      dadosOrdenados: null,
      corteTemporal: ['Ultimos Anos', 'Ultimos Meses'],
      corteTemporalEscolhido: 'Ultimos Anos',
      demanda: {
        data: [ 'datasets', 'labels' ],
      },
      ultimoClickIdSub: 0,
      subSelecionada: null,
      subs: [],
      subSel: '',
      mapa: {
        mensal: {},
        anual: {},
      },
    }
  },

  created () {
    this.chart.data = {}
    let data = new Date()
    Promise.all([
      this.$store.dispatch('servicosSME/buscarTMACrecheMensal', { inicio: this.getDataMenos() }),
      this.$store.dispatch('servicosSME/buscarTMACrecheMensal', { inicio: this.getDataMenos(6) }),
      this.$store.dispatch('servicosSME/buscarTMACrecheAnual', { inicio: null }),
      this.$store.dispatch('servicosSME/buscarFilaCrecheRegionalMensal', { intervalo: 'ULTIMO_SEMESTRE' }),
    ])
      .then((respostas) => {
        //{fonte: fonte, data: dataRef}
        this.fonte = respostas[0].sigla_orgao + '-' + respostas[0].fonte
        this.dataRef = new Date(respostas[0].data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

        this.subs = _.orderBy(SPMapaNomes, 'nome')
        this.dadosDiarios = respostas[0].data
        this.carregarDadosDiarios(respostas[0].data)
        this.ordenarDadosAnuais(respostas[2].data)
        this.ordernarDadosMensais(respostas[1].data)
        this.ordernarDemanda(respostas[3].data)
        this.updateDashboard()

        this.mapa = { mensal: respostas[1].data, anual: respostas[2].data }
        this.pintarMapa(_.cloneDeep(this.mapa.anual))
      })
  },

  methods: {
    rodapeData (d, data) {
      // :footerText="$t('rodape.fonteData', {fonte: 'graficosEducacao.fonte', data: rodapeData(-1)})"
      return MethGlob.rodapeData(d, data)
    },
    getDataMenos (meses, anos) {
      let data = new Date()
      if (anos) data.setFullYear(data.getFullYear() - anos)
      if (meses) data.setMonth(data.getMonth() - meses)
      return data.getFullYear() + '-' + (data.getMonth() + 1) + '-01'
    },
    pintarMapa (data) {
      let d = _.groupBy(data, 'id')
      let tamanho = d[1].length
      let dados = []
      for (let sub in d) {
        d[sub][tamanho - 1]['bercario_i'] = d[sub][tamanho - 1]['bercario_i'] + d[sub][tamanho - 1]['bercario_ii'] + d[sub][tamanho - 1]['mini_grupo_i'] + d[sub][tamanho - 1]['mini_grupo_ii']
        dados.push(d[sub][tamanho - 1])
      }

      dados = _.orderBy(dados, 'bercario_i')

      let colorScale = d3.scaleLinear()
        .domain([0.1, dados[dados.length - 1]['bercario_i']])
        .range([this.mapaCores.claro, this.mapaCores.escuro])

      dados.forEach(o => {
        let id = 'sub' + o.id
        this.$refs.mapa.pintarRegiao(id, colorScale(o['bercario_i']))
      })

      this.$refs.mapa.setLegenda(dados[0]['bercario_i'], dados[dados.length - 1]['bercario_i'], 'Tempo Médio de Atendimento em Dias')
      this.criarlegenda(this.mapaCores)
    },
    criarlegenda (cores) {
      this.$refs.mapa.definirLegenda([cores.claro, cores.medio, cores.escuro], [this.$t('mainDashboard.legendaTitulo'), this.$t('mainDashboard.legendaBaixa'), this.$t('mainDashboard.legendaMedia'), this.$t('mainDashboard.legendaAlta')])
    },

    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickNomeSub !== id) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
        this.subSelecionada = this.$refs.mapa.nomes[idNum].nome
        this.$refs.mapa.emulateClick(id)
      } else {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        this.subSelecionada = null
      }
      this.subSel = _.find(this.subs, (e) => { return e.nome === this.subSelecionada })
      this.refreshDashboard()
    },

    updateMultiSelect (value) {
      if (!value) {
        value = this.subSel
      }
      this.filtrarPorRegiao('sub' + value.id)
    },

    updateDashboard () {
      let dados = _.cloneDeep(this.anual.data)
      let options = _.cloneDeep(this.getOptions('ANO', 'TEMPO MEDIO DE ATENDIMENTO (DIAS)', this.subSelecionada))

      this.$set(this.chart, 'data', dados[this.ultimoClickIdSub])
      this.$set(this.chart, 'options', options)
    },

    refreshDashboard () {
      if (this.corteTemporalEscolhido == this.corteTemporal[0]) {
        let dados = _.cloneDeep(this.anual.data)
        let options = _.cloneDeep(this.getOptions('ANO', 'TEMPO MEDIO DE ATENDIMENTO (DIAS)', this.subSelecionada))
        //  QUANDO SE FAZ O RENDERCHART, AS CONFIGURAÇÕES DEFAULT DO VA-CHART SAO IGNORADAS
        this.$refs.chart.$refs.chart.renderChart(dados[this.ultimoClickIdSub], options)
      } else {
        let datasets = []
        this.mensal.data[this.ultimoClickIdSub].datasets.forEach(e => { datasets.push(e) })
        this.demanda.data[this.ultimoClickIdSub].datasets.forEach(e => { datasets.push(e) })
        let aux = _.cloneDeep(datasets)

        let data = { 'datasets': aux, 'labels': this.mensal.data[this.ultimoClickIdSub].labels }
        let options = this.getchartOptions('MES/ANO', 'TEMPO MÉDIO DE ATENDIMENTO (DIAS)', datasets, this.subSelecionada)
        this.$refs.chart.$refs.chart.renderChart(data, options)
      }

      this.carregarDadosDiarios(this.dadosDiarios)
    },

    updatesub (value) {
      this.corteTemporalEscolhido = value
      if (this.corteTemporalEscolhido == this.corteTemporal[0]) { this.pintarMapa(_.cloneDeep(this.mapa.anual)) } else { this.pintarMapa(_.cloneDeep(this.mapa.mensal)) }

      this.refreshDashboard()
    },

    getchartOptions (xAxixLabel, yAxixLabel, chartData, titulo) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            clamp: true,
          },
        },
        title: {
          display: true,
          text: 'TEMPO MÉDIO DE ATENDIMENTO - FILA DA CRECHE - ' + (titulo || 'São Paulo'),
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].yAxisID == 'LineAxis') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + currentValue
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + MethGlob.thousandSeparator(currentValue)
              }
            },
          },
        },
        maintainAspectRatio: false,
        aspectRatio: 4,
        responsive: true,
        scales: {
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              id: 'BarAxis',
              position: 'right',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'TAMANHO FILA DA CRECHE',
              },
              ticks: {
                callback: function (value, index, values) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            },
            {
              id: 'LineAxis',
              position: 'left',
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: yAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            },
          ],
        },
      }
    },

    ordenarDadosAnuais (d) {
      let dados = _.groupBy(d, 'id')
      let datasets = []
      let labels = []
      datasets.push(this.organizar(dados))

      for (let sub in dados) {
        let bercario_i = []
        let bercario_ii = []
        let mini_grupo_i = []
        let mini_grupo_ii = []

        dados[sub].forEach(ano => {
          if (!labels.includes(ano.ano_letivo)) labels.push(ano.ano_letivo)
          bercario_i.push(ano.bercario_i)
          bercario_ii.push(ano.bercario_ii)
          mini_grupo_i.push(ano.mini_grupo_i)
          mini_grupo_ii.push(ano.mini_grupo_ii)
        })
        let d = [
          { data: bercario_i, label: this.$t('graficosEducacao.turmasCreche.bercario_i_eta') },
          { data: bercario_ii, label: this.$t('graficosEducacao.turmasCreche.bercario_ii_eta') },
          { data: mini_grupo_i, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_i_eta') },
          { data: mini_grupo_ii, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_ii_eta') },
        ]
        let dataset = []
        let i = 6
        for (let categoria of d) {
          dataset.push({
            label: 'TMA para ' + categoria.label,
            fill: false,
            backgroundColor: this.cores[0][i],
            borderColor: this.cores[0][i++],
            data: categoria.data,
            type: 'line',
            yAxisID: 'LineAxis',
            pointStyle: 'rect',
            datalabels: {
              display: false,
            },
          })
        }

        datasets.push({ datasets: dataset, labels: labels })
      }

      this.anual = { data: datasets }
    },

    ordernarDadosMensais (d) {
      let dados = _.groupBy(d, 'id')
      let datasets = []
      let labels = []

      datasets.push(this.organizar(dados))

      for (let sub in dados) {
        let bercario_i = []
        let bercario_ii = []
        let mini_grupo_i = []
        let mini_grupo_ii = []

        dados[sub].forEach(ano => {
          let dt = new Date(ano.dt_cadastro)
          let dtAbrev = MethGlob.mapeiaMesAbreviacao(dt.getMonth() + 1).abrev + '/' + dt.getFullYear()
          if (!labels.includes(dtAbrev)) labels.push(dtAbrev)

          bercario_i.push(ano.bercario_i)
          bercario_ii.push(ano.bercario_ii)
          mini_grupo_i.push(ano.mini_grupo_i)
          mini_grupo_ii.push(ano.mini_grupo_ii)
        })

        let d = [
          { data: bercario_i, label: this.$t('graficosEducacao.turmasCreche.bercario_i_eta') },
          { data: bercario_ii, label: this.$t('graficosEducacao.turmasCreche.bercario_ii_eta') },
          { data: mini_grupo_i, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_i_eta') },
          { data: mini_grupo_ii, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_ii_eta') },
        ]
        let dataset = []
        let i = 6
        for (let categoria of d) {
          dataset.push({
            label: 'TMA para ' + categoria.label,
            fill: false,
            backgroundColor: this.cores[0][i],
            borderColor: this.cores[0][i++],
            data: categoria.data,
            type: 'line',
            yAxisID: 'LineAxis',
            datalabels: {
              labels: {
                title: null,
              },
            },
            pointStyle: 'rect',
          })
        }

        datasets.push({ datasets: dataset, labels: labels })
      }

      this.mensal = { data: datasets, options: this.getOptions('MES/ANO', 'DIAS') }
    },

    organizar (dados, aux_campo, tipo_grafico) {
      aux_campo = aux_campo || ''

      let labels = []
      let bercario_i = []
      let bercario_ii = []
      let mini_grupo_i = []
      let mini_grupo_ii = []

      for (let i = 0; i < dados[1].length; i++) {
        bercario_i[i] = 0
        bercario_ii[i] = 0
        mini_grupo_i[i] = 0
        mini_grupo_ii[i] = 0
      }

      for (let sub in dados) {
        for (let i = 0; i < dados[sub].length; i++) {
          if (dados[sub][i].ano_letivo) {
            if (!labels.includes(dados[sub][i].ano_letivo)) labels.push(dados[sub][i].ano_letivo)
          } else {
            let dt = new Date(dados[sub][i].dt_cadastro)
            let dtAbrev = MethGlob.mapeiaMesAbreviacao(dt.getMonth() + 1).abrev + '/' + dt.getFullYear()
            if (!labels.includes(dtAbrev)) labels.push(dtAbrev)
          }

          bercario_i[i] += !isNaN(dados[sub][i][aux_campo + 'bercario_i']) ? dados[sub][i][aux_campo + 'bercario_i'] : 0
          bercario_ii[i] += !isNaN(dados[sub][i][aux_campo + 'bercario_ii']) ? dados[sub][i][aux_campo + 'bercario_ii'] : 0
          mini_grupo_i[i] += !isNaN(dados[sub][i][aux_campo + 'mini_grupo_i']) ? dados[sub][i][aux_campo + 'mini_grupo_i'] : 0
          mini_grupo_ii[i] += !isNaN(dados[sub][i][aux_campo + 'mini_grupo_ii']) ? dados[sub][i][aux_campo + 'mini_grupo_ii'] : 0
        }
      }

      let d = [
        { data: bercario_i, label: this.$t('graficosEducacao.turmasCreche.bercario_i_eta') },
        { data: bercario_ii, label: this.$t('graficosEducacao.turmasCreche.bercario_ii_eta') },
        { data: mini_grupo_i, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_i_eta') },
        { data: mini_grupo_ii, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_ii_eta') },
      ]

      for (let categoria of d) {
        for (let e in categoria.data) {
          categoria.data[e] = categoria.data[e] == 0 ? 0 : Number((categoria.data[e] / 32).toFixed(0))
        }
      }

      let dataset = []
      let i = 6
      for (let categoria of d) {
        dataset.push({
          categoryPercentage: 0.75,
          barPercentage: 1.0,
          label: (tipo_grafico ? 'Fila para ' : 'TMA para ') + categoria.label,
          fill: false,
          backgroundColor: this.cores[tipo_grafico ? 1 : 0][i],
          borderColor: this.cores[tipo_grafico ? 1 : 0][i++],
          data: categoria.data,
          type: tipo_grafico || 'line',
          yAxisID: tipo_grafico ? 'BarAxis' : 'LineAxis',
          pointStyle: 'rect',
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value) => MethGlob.thousandSeparator(value),
            anchor: 'start',
            rotation: -90,
            align: 'end',
            display: tipo_grafico ? 'true' : false,
            labels: {
              title: null,
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
          },
        })
      }
      return { datasets: dataset, labels: labels }
    },

    carregarDadosDiarios (ultimo_mes) {
      ultimo_mes = _.groupBy(ultimo_mes, 'id')
      let aux = this.ultimoClickIdSub == 0 ? this.getDiarioMunicipal(ultimo_mes) : ultimo_mes[this.ultimoClickIdSub][0]
      this.diario.bercario_i = aux['bercario_i']
      this.diario.bercario_ii = aux['bercario_ii']
      this.diario.mini_grupo_i = aux['mini_grupo_i']
      this.diario.mini_grupo_ii = aux['mini_grupo_ii']
    },

    getDiarioMunicipal (dados) {
      let bercario_i = 0
      let bercario_ii = 0
      let mini_grupo_i = 0
      let mini_grupo_ii = 0

      for (let sub in dados) {
        bercario_i += !isNaN(dados[sub][0]['bercario_i']) ? dados[sub][0]['bercario_i'] : 0
        bercario_ii += !isNaN(dados[sub][0]['bercario_ii']) ? dados[sub][0]['bercario_ii'] : 0
        mini_grupo_i += !isNaN(dados[sub][0]['mini_grupo_i']) ? dados[sub][0]['mini_grupo_i'] : 0
        mini_grupo_ii += !isNaN(dados[sub][0]['mini_grupo_ii']) ? dados[sub][0]['mini_grupo_ii'] : 0
      }

      bercario_i = bercario_i == 0 ? 0 : Number((bercario_i / 32).toFixed(0))
      bercario_ii = bercario_ii == 0 ? 0 : Number((bercario_ii / 32).toFixed(0))
      mini_grupo_i = mini_grupo_i == 0 ? 0 : Number((mini_grupo_i / 32).toFixed(0))
      mini_grupo_ii = mini_grupo_ii == 0 ? 0 : Number((mini_grupo_ii / 32).toFixed(0))

      return { 'bercario_i': bercario_i, 'bercario_ii': bercario_ii, 'mini_grupo_i': mini_grupo_i, 'mini_grupo_ii': mini_grupo_ii }
    },

    ordernarDemanda (d) {
      let dados = _.groupBy(d, 'id_subprefeitura')
      let datasets = []
      let labels = []
      datasets.push(this.organizar(dados, 'media_', 'bar'))

      for (let sub in dados) {
        let bercario_i = []
        let bercario_ii = []
        let mini_grupo_i = []
        let mini_grupo_ii = []

        dados[sub].forEach(ano => {
          let dt = new Date(ano.dt_cadastro)
          let dtAbrev = MethGlob.mapeiaMesAbreviacao(dt.getMonth() + 1).abrev + '/' + dt.getFullYear()
          if (!labels.includes(dtAbrev)) labels.push(dtAbrev)

          bercario_i.push(ano.media_bercario_i)
          bercario_ii.push(ano.media_bercario_ii)
          mini_grupo_i.push(ano.media_mini_grupo_i)
          mini_grupo_ii.push(ano.media_mini_grupo_ii)
        })

        let d = [
          { data: bercario_i, label: this.$t('graficosEducacao.turmasCreche.bercario_i_eta') },
          { data: bercario_ii, label: this.$t('graficosEducacao.turmasCreche.bercario_ii_eta') },
          { data: mini_grupo_i, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_i_eta') },
          { data: mini_grupo_ii, label: this.$t('graficosEducacao.turmasCreche.mini_grupo_ii_eta') },
        ]
        let dataset = []
        let i = 6
        for (let categoria of d) {
          dataset.push({
            categoryPercentage: 0.75,
            barPercentage: 1.0,
            label: 'Fila para ' + categoria.label,
            fill: false,
            backgroundColor: this.cores[1][i],
            borderColor: this.cores[1][i++],
            data: categoria.data,
            yAxisID: 'BarAxis',
            pointStyle: 'circle',
            datalabels: {
              color: CorUtils.getCorPorNomeSp360('preto-escuro'),
              formatter: (value) => MethGlob.thousandSeparator(value),
              anchor: 'start',
              rotation: -90,
              align: 'end',
              display: 'true',
              labels: {
                value: {
                  font: {
                    weight: 'bold',
                  },
                },
              },
            },
          })
        }

        datasets.push({ datasets: dataset, labels: labels })
      }

      datasets[0].labels = datasets[1].labels

      this.demanda = { data: datasets, options: this.getOptions('MES/ANO', 'DIAS') }
    },

    getOptions (legendaX, legendaY, titulo) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        legend: {
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
        },
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 4,
        title: {
          display: true,
          text: 'TEMPO MÉDIO DE ATENDIMENTO - ' + (titulo || 'São Paulo'),
        },
        plugins: {
          datalabels: {
            clamp: true,
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: true,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label + '  ' || ''
              label += MethGlob.thousandSeparator(tooltipItem.yLabel)
              return label
            },
          },
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
          }],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => MethGlob.thousandSeparator(value),
              },
              id: 'LineAxis',
              type: 'linear',
              position: 'left',
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.$t(legendaY || 'LegendaY'),
              },
            },
          ],
        },
      }
    },

  },
}
</script>

<style lang="scss" scoped>

#mapaSP {
    width: 25%;
    max-height: 35rem;
}

#chartTma {
  height: 35rem;
  width: 75%;
}

.flex-box{
  max-height: 50rem;
  width: 100%;
  display: flex;
}

#multiselects{
  justify-content: space-between;
}

.multiselect{
  width: 20rem;
}

</style>